export default __webpack_public_path__ + "static/media/icon_payment_type_kiosk-grey.b348c539.svg";